import React, { useCallback, useState, useEffect, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { BigNumber } from 'bignumber.js'

// utils
import { AuditOptions, ArtworksProps } from '../../constants/artwork'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
// import { MARKETTYPE, MARKETTYPEV3 } from '../../constants/bakery/nft'

// hooks
import { useActiveWeb3React } from '../../hooks'
import useModal from '../../hooks/bakery/useModal'
// import { useMarketLevel } from '../../state/market/hooks'
import useUserBids from '../../hooks/nft/useUserBids'
import useSellTokenTo from '../../hooks/nft/useSellTokenTo'
import useUpdateBid from '../../hooks/nft/useUpdateBid'
import useUserAsks from '../../hooks/nft/useUserAsks'
import useBid from '../../hooks/nft/useBidding'
import useCancelBid from '../../hooks/nft/useCancelBid'
import useRevokeExchange from '../../hooks/nft/useRevokeExchange'
import useAllowanceERC721 from '../../hooks/nft/useAllowanceERC721'
import useApproveERC721 from '../../hooks/nft/useApproveERC721'
import useSell from '../../hooks/nft/useSell'
import useAuction from '../../hooks/nft/useAuction'
import useAllowanceAll from '../../hooks/nft/useAllowanceAll'
import useApproveAllERC721 from '../../hooks/nft/useApproveAllERC721'
import useYam from '../../hooks/bakery/useYam'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import { userTokenAddress } from '../../userType/userTokenAddress'
import useBuy from '../../hooks/nft/useBuy'
import useAllowanceERC20 from '../../hooks/nft/useAllowanceERC20'
import { useAddPopup } from '../../state/application/hooks'
import useApproveERC20 from '../../hooks/nft/useApproveERC20'
import useAllowanceBid from '../../hooks/nft/useAllowanceBid'
import useApproveBid from '../../hooks/nft/useApproveBid'
import { useWalletModalToggle } from '../../state/application/hooks'
import useAllowanceVote from '../../hooks/nft/useAllowanceVote'
import useApproveVote from '../../hooks/nft/useApproveVote'
import useVoting from '../../hooks/nft/useVoting'
import useMaxBidPrice from '../../hooks/nft/useMaxBidPrice'
import { userTokenDecimals } from '../../userType/userTokenDecimals'
import { userTokenName } from '../../userType/userTokenName'

// components
import Loader from '../Loader'
import { AutoRow } from '../Row'
import { ButtonNewConfirmed } from '../Button'
import AuditModal from '../../pages/BakeryArtworks/components/AuditModal'
import BiddingModal from '../../pages/Artworks/components/BiddingModal'
import SellComboModal from '../../pages/Restaurant/components/SellComboModal'
import VoteModal from '../../pages/BakeryArtworks/components/VoteModal'
import Mark from '../../pages/Home/components/Mark'
import InsufficientModal from './modal/InsufficientModal'
import TransferBtn from './button/TransferBtn'

// service
import { auditArtworks } from '../../service/nft'


const HotRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: wrap;
    justify-content: center;
  `}
`
const Button = styled(ButtonNewConfirmed)`
  padding: 0;
  border: none;
  font-size: 14px;
  width: 130px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  align-self: flex-start;
  border-radius: 35px;
  z-index: 0;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-self: center; 
  `}
`
const UpgradeTxt = styled(Button)`
  margin-top: -5px;
  margin-left: -20px;
  width: 165px!important;
  height: 50px!important;
  text-align: center;
  font-size: 18px;
  color: #FFF3E0;
  text-shadow: 0px 3px 4px #FF8401;
  cursor: pointer;
  animation:scaleMove 2s linear	2s infinite;
  -webkit-animation:scaleMove 2s linear	2s infinite;
  transform: scale(0.8);
  @keyframes scaleMove
  {
    10% {
      transform: scale(1)
    }
    20% {
      transform: scale(0.8)
    }
    100% {
      transform: scale(0.8)
    }
  }
`
const BalanceBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > button {
    width: 130px;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: wrap;
    & > button {
      margin-bottom: 10px;
    }
  `}
`
const VoteButton = styled(ButtonNewConfirmed)`
  width: 130px;
  height: 40px;
  flex-shrink: 0;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 10px;
    margin-right: 16px;
  `}
`
const VoteAutoRow = styled.div`
  flex-wrap: nowrap;
  justify-content: center;
  display:flex;
  align-items:center;
`
// const SalesRow = styled.div`
//   background-color: #F7E4CE;
//   border-radius: 10px;
//   font-family: 'Baloo Da';
//   color: ${({ theme }) => theme.bsText7};
//   height: 40px;
//   line-height: 40px;
//   text-align: center;
//   margin-top: 24px;
// `

export default function InfoButton ({
  artwork, type, status, canReview, updateNum, setUpdateNum, isMyArtwork, tokenName
}: {
  artwork: ArtworksProps, type: string, status: number, canReview: boolean, updateNum: number, setUpdateNum: any, isMyArtwork?: boolean, tokenName?: string
}) {
  const { account, library, chainId } = useActiveWeb3React()
  // const level = useMarketLevel()
  const theme = useContext(ThemeContext)
  const symbol = tokenName || 'BAKE'

  const [curStatus, setCurStatus] = useState(status)

  // 我的竞价单币种
  const [resetSymbol, setResetSymbol] = useState(symbol)
  useEffect(() => {
    if (account) {
      setResetSymbol(symbol)
    }
  }, [symbol, account])


  const addPopup = useAddPopup()
  const toggleWalletModal = useWalletModalToggle()

  let noAsked = false
  if (!artwork.price) {
    noAsked = true
  }

  let decimals = userTokenDecimals(symbol)

  // bake balance
  const [bakeBalance, setBakeBalance] = useState(0)
  const yam = useYam()
  const bakeryBalance = useTokenBalance(userTokenAddress(yam, symbol))
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance, decimals)
    setBakeBalance(balance)
  }, [yam, bakeryBalance, decimals])

 //授权投票
 const allowanceVote = useAllowanceVote()
 const [requestedApprovalVote, setRequestedApprovalVote] = useState(false)
 const onApproveVote = useApproveVote()
 const handleApproveVote = useCallback(async (event) => {
   try {
     setRequestedApprovalVote(true)
     const txHash = await onApproveVote()
     if (!txHash) {
       setRequestedApprovalVote(false)
     }
   } catch (e) {
     console.log(e)
   }
 }, [onApproveVote, setRequestedApprovalVote])

 // 投票
 const {onVote} = useVoting(artwork.tokenId, type, artwork.owner) 
 const handleVote = useCallback(async (amount: string) => {
   try {
     const txHash = await onVote(amount)
     console.log('handleVote', txHash)
   } catch (e) {
     console.log(e)
   }
 }, [onVote])

 const handVote = ((event: any) => {
   onVoting()
 })

 const [onVoting] = useModal(
   <VoteModal
     onConfirm={handleVote}
     tokenId={artwork.tokenId}
     nftType={artwork.nftType}
     nftId={artwork.nftId}
     name={artwork.name}
     type={type}
   />
 )

  const handleSell = async(realPrice: string, tokenName?: string) => {
    const txHash = await onSell(realPrice,tokenName)
    if (txHash) {
      setUpdateNum(updateNum+1)
    }
  }
  // Order
  const { onSell } = useSell(artwork.tokenId, type)
  const [artworkExchange] = useModal(
    <SellComboModal
      marketType={type}
      onConfirm={handleSell}
      tokenName={symbol}
      title="Please set the selling price"
    />,
  )
 
  // Auction
  const { onAuction } = useAuction(artwork.tokenId, artwork.nftType?.toString())
  const [auctionkExchange] = useModal(
    <SellComboModal
      marketType={type}
      onConfirm={onSell}
      tokenName={symbol}
      title="Please set the opening price"
      type="Auction"
      onAuction={onAuction}
    />,
  )

  const onPresentExchange = useCallback(async (event, type) => {
    if (type === 'sell') {
      artworkExchange()
    } else if (type === 'Auction') {
      auctionkExchange()
    }
  }, [artworkExchange, auctionkExchange])

  // Revoke
  const { onRevokeExchange } = useRevokeExchange(artwork.tokenId, type)
  const [requestedRevoke, setRequestedRevoke] = useState(false)
  const handleRevoke = useCallback(async () => {
    try {
      setRequestedRevoke(true)
      const txHash = await onRevokeExchange()
      if (!txHash) {
        setRequestedRevoke(false)
      } else {
        // reset allowanceSell
        setUpdateNum(updateNum+1)
        setResetApproval(true)
        setTimeout(() => {
          setRequestedRevoke(false)
          setResetApproval(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onRevokeExchange, updateNum, setUpdateNum])

  const [openInsufficientModal] = useModal(
    <InsufficientModal />
  )

  // Buy
  const [requestedBuy, setRequestedBuy] = useState(false)
  const { onBuy } = useBuy(artwork.tokenId, type, symbol)
  const buyArtwork = useCallback(async () => {
    console.log("---symbol---",symbol)
    try {
      if (artwork.price !== undefined && new BigNumber(bakeBalance).lt(!artwork.auctionPrice ? artwork.price : artwork.auctionPrice)) {
        openInsufficientModal()
        return
      }
      setRequestedBuy(true)
      let decimals = userTokenDecimals(symbol)
      const price = artwork.price && new BigNumber(+artwork.price).times(new BigNumber(10).pow(decimals)).toString()
      const txHash = await onBuy(price)
      if (!txHash) {
        setRequestedBuy(false)
      } else {
        setUpdateNum(updateNum+1)
        // Seccussful
        if (!library) return
        library
          .getTransactionReceipt(txHash.transactionHash)
          .then(receipt => {
            if (receipt) {
              addPopup(
                {
                  txn: {
                    hash: txHash.transactionHash,
                    success: receipt.status === 1,
                    summary: 'Buy Digital Artwork NFT'
                  }
                },
                txHash.transactionHash
              )
            }
          })
          .catch(error => {
            console.error(`failed to check transaction hash: ${txHash.transactionHash}`, error)
          })
      }
    } catch (e) {
      console.log(e)
    }
  }, [onBuy, library, addPopup, updateNum, setUpdateNum, bakeBalance, artwork, openInsufficientModal, symbol])

  // Allowance BAKE buy NFT
  const allowanceBuy = useAllowanceERC20(type, symbol)
  
  /**
   * BUY Artwork
   */
  // Approve
  const [requestedApprovalBuy, setRequestedApprovalBuy] = useState(false)
  const onApproveBuy = useApproveERC20(type, symbol)
  const handleApproveBuy = useCallback(async () => {
    try {
      setRequestedApprovalBuy(true)
      const txHash = await onApproveBuy()
      if (!txHash) {
        setRequestedApprovalBuy(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveBuy, setRequestedApprovalBuy])

  // 选择
  let defaultChecked = AuditOptions[0]
  const onSelectItem = async (e: any) => {
    defaultChecked = AuditOptions.filter(d => d.name === e.target.id)[0]
  }

  // 确认审核
  const onAudit = async (onDismiss: any, setPendingTx: any) => {
    if (!library) return
    setPendingTx(true)
    let time = Math.round(new Date().getTime()/1000).toString()
    library
      .send('eth_sign', [account, (artwork.tokenId + '-' + time)])
      .then(signature => {
        let param = {
          nftType: artwork.nftType,
          address: account,
          timestamp: time,
          nftId: artwork.tokenId,
          status: defaultChecked.value,
          signature: signature
        }
        auditArtworks(chainId as number, param, (err: any, d: any) => {
          if (err) return
          if (d.code !== 0) return
          if (defaultChecked.value === 1) {
            setCurStatus(1)
          }
          onDismiss()
          setPendingTx(false)
        })
      })
      .catch(error => {
        setPendingTx(false)
        console.log('err', error)
      })
  }

  // 审核
  const [ReviewModal] = useModal(
    <AuditModal
      onConfirm={onAudit}
      options={AuditOptions}
      onSelectItem={onSelectItem}
      title="Review"
    />
  )

  // 获取我的竞价
  const [requestedBid, setRequestedBid] = useState(false)
  const getBids = useUserBids(type)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        if(d[0] + '-' + d[3] === artwork.nftId + '-' + artwork.nftType){
          let symbolReset = userTokenName(yam, d[2])
          setResetSymbol(symbolReset)
        }
        return d[0]
      })
      setIds(bidsId)
    }
  }, [getBids,artwork,yam])

  // 获取我的挂单
  const getAsks = useUserAsks(type)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])
  
  useEffect(() => {
    if (account) {
      getIds()
      getAskIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, account, requestedBid, artwork])

  // 将token卖给指定地址
  const {onSellBid} = useSellTokenTo(artwork.tokenId, type, symbol)
  const onSellTokenTo = useCallback(async (address: string, price?: any) => {
    try {
      const txHash = await onSellBid(address, price)
      if (txHash) {
        setUpdateNum(updateNum+1)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onSellBid, updateNum, setUpdateNum])

  // Bidding
  const {onBid} = useBid(artwork.tokenId, type, symbol) 
  const {onMaxBidPrice} = useMaxBidPrice(artwork.tokenId, artwork.nftType)
  const handleBid = async (amount: string) => {
    try {
      const txHash = await onBid(amount)
      txHash && artwork.auctionPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(decimals)).toString())
      if (txHash) {
        setRequestedBid(true)
        setUpdateNum(updateNum+1)
      }
    } catch (e) {
      console.log(e)
    }
  }
  const [bidding] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={handleBid}
      isBidding={true}
      name={artwork.name}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={type}
      auctionPrice={artwork.auctionPrice}
      tokenName={symbol}
      />,
  )
  const onBidding = useCallback(async () => {
    bidding()
  }, [bidding])

  // 查看竞价列表
  const [lookBidding] = useModal(
    <BiddingModal
      onConfirm={onBid}
      onSellTokenTo={onSellTokenTo}
      isBidding={false}
      name={artwork.name}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={type}
      auctionPrice={artwork.auctionPrice}
      tokenName={symbol}
      />,
  )
  const onLookBidding = useCallback(async () => {
    lookBidding()
  }, [lookBidding])

  // 更新竞价
  const {onUpdate} = useUpdateBid(artwork.tokenId, type, artwork.auctionPrice ? onMaxBidPrice : '',symbol)
  const handleUpdate = async (amount: string) => {
    try {
      const txHash = await onUpdate(amount)
      if (txHash) {
        setUpdateNum(updateNum+1)
      }
    } catch (e) {
      console.log(e)
    }
  }
  const [updateBid] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={handleUpdate}
      name={artwork.name}
      isBidding={true}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={type}
      auctionPrice={artwork.auctionPrice}
      tokenName={symbol}
      />,
  )

  const onUpdateBid = useCallback(async () => {
    updateBid()
  }, [updateBid])

  /**
   * BID Artwork
   */
  //Approve
  const allowanceBid = useAllowanceBid(type, symbol)
  const [requestedApprovalBid, setRequestedApprovalBid] = useState(false)
  const onApproveBid = useApproveBid(type, symbol)
  const handleApproveBid = useCallback(async (event) => {
    try {
      setRequestedApprovalBid(true)
      const txHash = await onApproveBid()
      if (!txHash) {
        setRequestedApprovalBid(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveBid, setRequestedApprovalBid])

  // 竞价
  const handBid = ((event: any) => {
    // ids：参与的竞价， aksIds：我的挂单
    if (ids.includes(artwork.tokenId)) {
      onUpdateBid()
      return
    }
    if (aksIds.includes(artwork.tokenId)) {
      onLookBidding()
    } else {
      onBidding()
    }
  })

  // 移除竞价
  const cancelBid = useCancelBid(artwork.tokenId, type, resetSymbol)
  const [requestedCancel, setRequestedCancel] = useState(false)
  const onCancelBid = useCallback(async(event) => {
    try {
      setRequestedCancel(true)
      const txHash = await cancelBid()
      if (!txHash) {
        setRequestedCancel(false)
      } else {
        setUpdateNum(updateNum+1)
        setTimeout(() => {
          setRequestedCancel(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [cancelBid, updateNum, setUpdateNum])

  // v2查询是否授权卖
  const [requestedApprovalAllExchange, setRequestedApprovalAllExchange] = useState(false)
  const allowanceSellAll = useAllowanceAll(
    {
      type: type,
      marketFlag: 'market',
      requested: requestedApprovalAllExchange
    }
  )
  const onApproveSellAll = useApproveAllERC721(type, 'market')
  const handleApproveSellAll = useCallback(
    async (event) => {
      try {
        setRequestedApprovalAllExchange(true)
        const txHash = await onApproveSellAll()
        if (!txHash) {
          setRequestedApprovalAllExchange(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalAllExchange(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApproveSellAll, setRequestedApprovalAllExchange]
  )

  /**
   * SELL Artwork
   */
  // Approve
  const [requestedApprovalExchange, setRequestedApprovalExchange] = useState(false)
  const [resetApproval, setResetApproval] = useState(false)
  const allowanceSell = useAllowanceERC721({
    tokenId: artwork.tokenId,
    type: type,
    requested: requestedApprovalExchange,
    reset: resetApproval
  })
  const onApproveSell = useApproveERC721(artwork.tokenId, type)
  const handleApproveSell = useCallback(
    async () => {
      try {
        setRequestedApprovalExchange(true)
        const txHash = await onApproveSell()
        if (!txHash) {
          setRequestedApprovalExchange(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalExchange(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApproveSell, setRequestedApprovalExchange]
  )

  const Btn = () => {
    if (!account) {
      return <Button onClick={toggleWalletModal}>Connect Wallet</Button>
    }

    if (+curStatus === 0 || (artwork.status && +artwork.status === -1)) {
      return (
        <Button
          onClick={ReviewModal}
          disabled={!(canReview && artwork.name)}
          >
            {'Review'}
        </Button>
      )
    }

    // console.log('----allowanceSellV3---', artwork.level, type)
    
    const myNft = artwork.hasOwnProperty('owner') ? artwork.owner?.toLowerCase() === account.toLowerCase() : isMyArtwork
    if (artwork.nftLevel === 'v1') {
      const disabledV1 = true
      const disabledStyle = disabledV1 ? {
        background: '#C4C4C4',
        color: '#E9E9E9'
      } : {}
      // 不允许卖
      // if ((artwork.owner?.toLowerCase() === account.toLowerCase()) && !allowanceSell) {
      if (myNft && !allowanceSell) {
        return (
          <Button
            onClick={handleApproveSell}
            disabled={requestedApprovalExchange || !artwork.name || disabledV1}
            fontSize={14}
            height={40}
            altDisabledStyle={requestedApprovalExchange || !artwork.name || disabledV1}
            style={{...disabledStyle, ...{width: '213px'}}}
          >
            {requestedApprovalExchange ? (
              <AutoRow gap="6px" justify="center">
                Approving <Loader stroke="white" />
              </AutoRow>
            ) : (
              'Approve NFT Marketplace'
            )}
          </Button>
        )
      }

      // 不允许买
      if (artwork.price && !allowanceBuy.toNumber()) {
        return (
          <Button
            onClick={handleApproveBuy}
            disabled={requestedApprovalBuy || !artwork.name || disabledV1}
            altDisabledStyle={requestedApprovalBuy || !artwork.name || disabledV1}
            style={{...disabledStyle, ...{width: '213px'}}}
          >
            {
              requestedApprovalBuy ? (
                <AutoRow gap="6px" justify="center">
                  Approving <Loader stroke="white" />
                </AutoRow>
              ) : 'Approve NFT Marketplace'
            }
          </Button>
        )
      }
      // 允许卖
      // if ((artwork.owner?.toLowerCase() === account.toLowerCase()) && allowanceSell) {
      if (myNft && allowanceSell) {
        return (
          <Button
            disabled={!artwork.name || disabledV1}
            onClick={event => {onPresentExchange(event, 'sell')}}
            style={{...disabledStyle, ...{width: '213px'}}}
          >Sell on Exchange</Button>
        )
      }

      // 已经挂单
      // if ((artwork.owner?.toLowerCase() === account.toLowerCase()) && artwork.price) {
      if(aksIds.includes(artwork.tokenId as never) && artwork.price) {
        return (
          // <Button
          //   disabled={requestedRevoke || !artwork.name}
          //   onClick={handleRevoke}
          //   altDisabledStyle={requestedRevoke || !artwork.name}
          // >
          //   {
          //     requestedRevoke ? (
          //       <AutoRow gap="6px" justify="center">
          //         Revoking <Loader stroke="white" />
          //       </AutoRow>
          //     ) : (
          //       'Revoke'
          //     )
          //   }
          // </Button>
          <UpgradeTxt
            disabled={requestedRevoke || !artwork.tokenId}
            onClick={handleRevoke}
            altDisabledStyle={requestedRevoke || !artwork.tokenId}
          >
            {
              requestedRevoke ? (
                <AutoRow gap="6px" justify="center">
                  Revoking <Loader stroke="white" />
                </AutoRow>
              ) : (
                'Revoke'
              )
            }
          </UpgradeTxt>
        )
      }

      // 买
      if (artwork.price && allowanceBuy.toNumber()) {
        return (
          <Button
            onClick={buyArtwork}
            disabled={requestedBuy || !artwork.name || noAsked || disabledV1}
            altDisabledStyle={requestedBuy || !artwork.name || noAsked || disabledV1}
            style={{...disabledStyle}}
          >{
            requestedBuy ? (
              <AutoRow gap="6px" justify="center">
                Pending <Loader stroke="white" />
              </AutoRow>
            ) : 
              <>
                {/* <img src={disabledV1 ? '/images/bakery/icon_bake_btn_gray.svg' : '/images/bakery/icon_bake_btn.svg'} style={{marginRight: '5px'}} alt="" /> */}
                {'Buy'}
              </>
          }</Button>
        )
      }
    } else {
      const disabledV2 = artwork.nftLevel === 'v2' ? true : false
      const disabledStyle = disabledV2 ? {
        background: '#C4C4C4',
        color: '#E9E9E9'
      } : {}
      // 不允许卖
      // if ((artwork.owner?.toLowerCase() === account.toLowerCase()) && !allowanceSellAll) {
      if (myNft && !allowanceSellAll) {
        return (
          <Button
            onClick={handleApproveSellAll}
            disabled={requestedApprovalAllExchange || disabledV2}
            fontSize={14}
            height={40}
            altDisabledStyle={requestedApprovalAllExchange || disabledV2}
            style={{...disabledStyle, ...{width: '213px'}}}
          >
            {requestedApprovalAllExchange ? (
              <AutoRow gap="6px" justify="center">
                Approving <Loader stroke="white" />
              </AutoRow>
            ) : (
              'Approve NFT Marketplace'
            )}
          </Button>
        )
      }

      // 不允许买
      if (artwork.price && !allowanceBid.toNumber()) {
        return (
          <Button
            onClick={handleApproveBid}
            disabled={requestedApprovalBid || (disabledV2 && (artwork.owner?.toLowerCase() !== account.toLowerCase()))}
            altDisabledStyle={requestedApprovalBid || (disabledV2 && (artwork.owner?.toLowerCase() !== account.toLowerCase()))}
            style={{
              marginRight: 16,
              width: '213px',
              ...((artwork.owner?.toLowerCase() !== account.toLowerCase()) && disabledStyle)
            }}
          >
            {
              requestedApprovalBid ? (
                <AutoRow gap="6px" justify="center">
                  Approving <Loader stroke="white" />
                </AutoRow>
              ) : 'Approve NFT Marketplace'
            }
          </Button>
        )
      }

      // 参与竞价
      if (ids.includes(artwork.tokenId)) {
        let requestedUpdate:any = symbol !== resetSymbol
        return (
          <BalanceBtn>
            <Button
              onClick={handBid}
              disabled={requestedUpdate || disabledV2}
              altDisabledStyle={requestedUpdate || disabledV2}
              style={{
                marginRight: 16,
                ...disabledStyle
              }}
            >
              update
            </Button>
            <Button
              disabled={requestedCancel}
              onClick={onCancelBid}
              altDisabledStyle={requestedCancel}
            >
              { 
                requestedCancel ? (
                  <AutoRow gap="6px" justify="center">
                    Pending <Loader stroke="white" />
                  </AutoRow>
                ) : (
                  'Cancel'
                )
              }
            </Button>
          </BalanceBtn>
        )
      }

      // 在卖的
      // if ((artwork.owner?.toLowerCase() === account.toLowerCase()) && artwork.price) {
      if (aksIds.includes(artwork.tokenId as never) && artwork.price) {
        return (
          <BalanceBtn>
            {
            !disabledV2
              ? <Button
                  disabled={requestedRevoke}
                  onClick={handleRevoke}
                  altDisabledStyle={requestedRevoke}
                  style={{
                    marginRight: 16
                  }}
                >
                  {
                    requestedRevoke ? (
                      <AutoRow gap="6px" justify="center">
                        Revoking <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Revoke'
                    )
                  }
                </Button>
              : <UpgradeTxt
                  disabled={requestedRevoke || !artwork.tokenId}
                  onClick={handleRevoke}
                  altDisabledStyle={requestedRevoke || !artwork.tokenId}
                >
                  {
                    requestedRevoke ? (
                      <AutoRow gap="6px" justify="center">
                        Revoking <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Revoke'
                    )
                  }
                </UpgradeTxt>
            }
            <Button
              disabled={disabledV2}
              onClick={handBid}
              altDisabledStyle={disabledV2}
              style={{
                marginRight: 16,
                ...disabledStyle
              }}
            >
              <>
                {/* <img src={disabledV2 ? '/images/bakery/icon_bid_btn_gray.svg' : '/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" /> */}
                Bidding
              </>
            </Button>
          </BalanceBtn>
        )
      }

      // 在钱包里的
      // if ((artwork.owner?.toLowerCase() === account.toLowerCase()) && !artwork.price) {
      if (myNft && !artwork.price) {
        return (
          <BalanceBtn>
            <Button
              onClick={event => {onPresentExchange(event, 'Auction')}}
              style={{
                marginRight: 16,
                // background: '#FFFDFA',
                border: '1px solid #FF7A00',
                // color: '#FF7A00'
                background: theme.btnBg3,
                WebkitBackgroundClip: 'text',
                color: 'transparent'
              }}
            >
              Auction
            </Button>
            <Button
              onClick={event => {onPresentExchange(event, 'sell')}}
            >Sell</Button>
            <TransferBtn
              artwork={artwork} 
              marketType={type}
            />
          </BalanceBtn>
        )
      }

      if (!artwork.auctionPrice) {
        return (
          <BalanceBtn>
            <Button
              style={{
                marginRight: 16,
                ...disabledStyle
              }}
              onClick={buyArtwork}
              disabled={requestedBuy || ids.includes(artwork.tokenId) || noAsked || disabledV2}
              altDisabledStyle={requestedBuy || ids.includes(artwork.tokenId) || noAsked || disabledV2}
            >{
              requestedBuy ? (
                <AutoRow gap="6px" justify="center">
                  Pending <Loader stroke="white" />
                </AutoRow>
              ) : 
              <>
                {/* <img src={disabledV2 ? '/images/bakery/icon_bake_btn_gray.svg' : '/images/bakery/icon_bake_btn.svg'} style={{marginRight: '5px'}} alt="" /> */}
                {'Buy'}
              </>
            }</Button>
            <Button
              onClick={handBid}
              disabled={noAsked || disabledV2}
              altDisabledStyle={noAsked || disabledV2}
              style={{
                marginRight: 16,
                color: noAsked ? '' : theme.white,
                ...disabledStyle
              }}
            >
              <>
                {/* <img src={disabledV2 ? '/images/bakery/icon_bid_btn_gray.svg' : '/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" /> */}
                {'Bidding'}
              </>
            </Button>
          </BalanceBtn>
        )
      }

      if (artwork.auctionPrice) {
        return (
          <Button
            onClick={handBid}
            disabled={noAsked || disabledV2}
            altDisabledStyle={noAsked || disabledV2}
            width={240}
            style={{
              marginRight: 16,
              color: noAsked ? '' : theme.white,
              ...disabledStyle
            }}
          >
            <>
              {/* <img src={disabledV2 ? '/images/bakery/icon_bid_btn_gray.svg' : '/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" /> */}
              Bidding
            </>
          </Button>
        )
      }
    }

    return null
  }

  return <>
    <HotRow>
      {Btn()}
    {/* {
      account ? (
        +status === 0 ? (<Button
          onClick={ReviewModal}
          disabled={!(canReview && artwork.name)}
          >
            {'Review'}
          </Button>
        ) :  (isMyArtwork || artwork.owner === account)
          ? level !== 'v1' && ids.includes(artwork.tokenId) ?
          <BalanceBtn>
            <Button
              onClick={handBid}
              style={{
                marginRight: 16,
                background: theme.bg1,
                border: `1px solid ${theme.bsText7}`,
                color: theme.bsText7
              }}
            >
              update
            </Button>
            <Button
              disabled={requestedCancel}
              onClick={onCancelBid}
              altDisabledStyle={requestedCancel}
            >
              { 
                requestedCancel ? (
                  <AutoRow gap="6px" justify="center">
                    Pending <Loader stroke="white" />
                  </AutoRow>
                ) : (
                  'Cancel'
                )
              }
            </Button>
          </BalanceBtn>
          : (artwork.price && +artwork.price > 0) ? (
            level === 'v1' ?
            <Button
              disabled={requestedRevoke || !artwork.name}
              onClick={handleRevoke}
              altDisabledStyle={requestedRevoke || !artwork.name}
            >
              {
                requestedRevoke ? (
                  <AutoRow gap="6px" justify="center">
                    Revoking <Loader stroke="white" />
                  </AutoRow>
                ) : (
                  'Revoke'
                )
              }
            </Button> :
            <BalanceBtn>
              <Button
                disabled={requestedRevoke}
                onClick={handleRevoke}
                altDisabledStyle={requestedRevoke}
                style={{
                  marginRight: 16
                }}
              >
                { 
                  requestedRevoke ? (
                    <AutoRow gap="6px" justify="center">
                      Revoking <Loader stroke="white" />
                    </AutoRow>
                  ) : (
                    'Revoke'
                  )
                }
              </Button>
              <Button
                onClick={handBid}
                style={{
                  marginRight: 16
                }}
              >
                <>
                  <img src={'/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" />
                  Bidding
                </>
              </Button>
            </BalanceBtn>
          ) : level === 'v1' ?  allowanceSell ? (
              <Button
                disabled={!artwork.name}
                onClick={event => {onPresentExchange(event, 'sell')}}
              >Sell on Exchange</Button>
            ) : (
              <Button
                onClick={handleApproveSell}
                disabled={requestedApprovalExchange || !artwork.name}
                fontSize={14}
                height={40}
                altDisabledStyle={requestedApprovalExchange || !artwork.name}
              >
                {requestedApprovalExchange ? (
                  <AutoRow gap="6px" justify="center">
                    Approving <Loader stroke="white" />
                  </AutoRow>
                ) : (
                  'Approve NFT Marketplace'
                )}
              </Button>
            ) : (
              allowanceSellAll ? (
                <BalanceBtn>
                  <Button
                    onClick={event => {onPresentExchange(event, 'Auction')}}
                    style={{
                      marginRight: 16,
                      background: '#FFFDFA',
                      border: '1px solid #AC562A',
                      color: '#AC562A'
                    }}
                  >
                    Auction
                  </Button>
                  <Button
                    onClick={event => {onPresentExchange(event, 'sell')}}
                  >Sell</Button>
                </BalanceBtn>
              ) : (
                <Button
                  onClick={handleApproveSellAll}
                  disabled={requestedApprovalAllExchange}
                  fontSize={14}
                  height={40}
                  altDisabledStyle={requestedApprovalAllExchange}
                >
                  {requestedApprovalAllExchange ? (
                    <AutoRow gap="6px" justify="center">
                      Approving <Loader stroke="white" />
                    </AutoRow>
                  ) : (
                    'Approve NFT Marketplace'
                  )}
                </Button>
              )
            )
          : artwork.price !== undefined && new BigNumber(bakeBalance).lt(!artwork.auctionPrice ? artwork.price : artwork.auctionPrice) ? (
            level === 'v1' ?
            <Button
              disabled={true}
              altDisabledStyle={true}
            >{'Insufficient ' + symbol + ' balance'}</Button>
            : <BalanceBtn>
                <Button
                disabled={true}
                altDisabledStyle={true}
                style={{
                  marginRight: 16
                }}
              >
                {'Insufficient ' + symbol + ' balance'}
              </Button>
              <Button
                disabled={true}
                altDisabledStyle={true}
              >
                {'Insufficient ' + symbol + ' balance'}
              </Button>
            </BalanceBtn>
          ) : level === 'v1' ? allowanceBuy?.toNumber() ? (
            <Button
              onClick={buyArtwork}
              disabled={requestedBuy || !artwork.name || noAsked}
              altDisabledStyle={requestedBuy || !artwork.name || noAsked}
            >{
              requestedBuy ? (
                <AutoRow gap="6px" justify="center">
                  Pending <Loader stroke="white" />
                </AutoRow>
              ) : 
                <>
                  <img src={'/images/bakery/icon_bake_btn.svg'} style={{marginRight: '5px'}} alt="" />
                  {'Buy'}
                </>
            }</Button>
          ) : (
            <Button
              onClick={handleApproveBuy}
              disabled={requestedApprovalBuy || !artwork.name}
              altDisabledStyle={requestedApprovalBuy || !artwork.name}
            >
              {
                requestedApprovalBuy ? (
                  <AutoRow gap="6px" justify="center">
                    Approving <Loader stroke="white" />
                  </AutoRow>
                ) : 'Approve NFT Marketplace'
              }
            </Button>
          ) : (
            allowanceBuy?.toNumber() && allowanceBid?.toNumber() ? (
              !artwork.auctionPrice ? (
                <BalanceBtn>
                  <Button
                    style={{
                      marginRight: 16
                    }}
                    onClick={buyArtwork}
                    disabled={requestedBuy || ids.includes(artwork.tokenId) || noAsked}
                    altDisabledStyle={requestedBuy || ids.includes(artwork.tokenId) || noAsked}
                  >{
                    requestedBuy ? (
                      <AutoRow gap="6px" justify="center">
                        Pending <Loader stroke="white" />
                      </AutoRow>
                    ) : 
                    <>
                      <img src={'/images/bakery/icon_bake_btn.svg'} style={{marginRight: '5px'}} alt="" />
                      {'Buy'}
                    </>
                  }</Button>
                  <Button
                    onClick={handBid}
                    disabled={noAsked}
                    altDisabledStyle={noAsked}
                    style={{
                      marginRight: 16,
                      color: noAsked ? '' : theme.bsText9
                    }}
                  >
                    <>
                      <img src={'/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" />
                      {'Bidding'}
                    </>
                  </Button>
                </BalanceBtn>
              ) : (
                <Button
                  onClick={handBid}
                  disabled={noAsked}
                  altDisabledStyle={noAsked}
                  width={240}
                  style={{
                    marginRight: 16,
                    color: noAsked ? '' : theme.bsText9
                  }}
                >
                  <>
                    <img src={'/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" />
                    Bidding
                  </>
                </Button>
              )
            ) : 
            <BalanceBtn>
              <Button
                onClick={handleApproveBid}
                disabled={requestedApprovalBid}
                altDisabledStyle={requestedApprovalBid}
                style={{
                  marginRight: 16
                }}
              >
                {
                  requestedApprovalBid ? (
                    <AutoRow gap="6px" justify="center">
                      Approving <Loader stroke="white" />
                    </AutoRow>
                  ) : 'Approve NFT Marketplace'
                }
              </Button>
              <Button
                onClick={handleApproveBid}
                disabled={requestedApprovalBid}
                altDisabledStyle={requestedApprovalBid}
              >
                {
                  requestedApprovalBid ? (
                    <AutoRow gap="6px" justify="center">
                      Approving <Loader stroke="white" />
                    </AutoRow>
                  ) : 'Approve NFT Marketplace'
                }
              </Button>
            </BalanceBtn>
          )
        ) : (
          <Button
            onClick={toggleWalletModal}>
            Connect Wallet
          </Button>
        )
      } */}
      {
        account && [
          // MARKETTYPE.BAKERYBSCARTWORK,
          // MARKETTYPE.BAKERYARTWORK,
          // MARKETTYPE.MEME, 
          // MARKETTYPE.MUSKDOGE, 
          // MARKETTYPE.ONEINCH,
          // MARKETTYPE.SFPARTWORK,
          // MARKETTYPE.LOVE,
          // MARKETTYPE.RACANFT
          'zanbuzhichi'
        ].includes(type) ? 
        allowanceVote?.toNumber() ?
          <VoteButton
            onClick={handVote}
            style={{
              background: theme.bsText1,
              border: `1px solid ${theme.bsText7}`,
              color: theme.bsText7
            }}
          >
            <>
              <img src={'/images/bakery/icon_vote_btn.svg'} style={{marginRight: '5px'}} alt="" />
              {'vote'}
              <Mark></Mark>
            </>
          </VoteButton>
        : 
          <VoteButton
            onClick={handleApproveVote}
            disabled={requestedApprovalVote}
            altDisabledStyle={requestedApprovalVote}
            style={{
              background: theme.bsText1,
              border: `1px solid ${theme.bsText7}`,
              color: theme.bsText7
            }}
          >
            {
              requestedApprovalVote ? (
                <VoteAutoRow>
                  Approving <Loader stroke="white" />
                </VoteAutoRow>
              ) : 'Approve Vote'
            }
          </VoteButton>
        : null
    }
    </HotRow>
    {/* {
      [MARKETTYPE.BAKERYBSCARTWORK, MARKETTYPEV3.BAKERYBSCARTWORKV3].includes(type) && artwork.attributes.creatorRoyalties
      ? <SalesRow style={artwork.level !== 'v3' ? {background: '#DBDBDB', color: '#898989'} : {}}>{artwork.attributes.creatorRoyalties ? artwork.attributes.creatorRoyalties / 100 : 0}% of sales will go to creator</SalesRow>
      : null
    } */}
  </>
}
